/* ===========================================================================
   ROVE NEXT -- UNMUTE BUTTON ON AUTOPLAYED VIDEOS. 15 October 2026.

   Videos in these sections autoplay muted (browsers only allow silent
   autoplay). This puts a small round sound button on the bottom left of each
   one; sound only starts when the visitor taps it -- never on load.

     sections/rn-hp-innovation-rows.liquid   [id^="rn-hp-inr-"]
     sections/rn-hp-motion.liquid            [id^="rn-hp-motion-"]
     sections/rn-moments.liquid              [id^="rn-mo-"]
     sections/rn-our-story.liquid            [id^="rn-story-"]
     PDP gallery (buy box main frame)        [id^="rn-bb-"] .bb-main  -- 16 Oct

   - One video has sound at a time: unmuting one re-mutes any other.
   - A video with sound that scrolls out of view is muted again, so audio
     never plays from something the visitor cannot see.
   - The button sits inside the video's own frame (its parent element), on the
     bottom left; rn-hp-motion's Pause button is bottom right, so they do not
     meet. Each section renders this file; it only runs once per page.
   - A section that re-mutes on every play (rn-hp-motion) checks the
     data-rn-unmuted attribute set here before doing so.
   - ONLY ON VIDEOS THAT HAVE SOUND. The button starts hidden and appears once
     the video is known to carry an audio track, so a silent clip never shows
     a button that does nothing. There is no one standard way to ask:
       Safari  -- video.audioTracks.length, once the metadata has loaded
       Firefox -- video.mozHasAudio, once the metadata has loaded
       Chrome / Edge -- webkitAudioDecodedByteCount: audio is decoded even
         while muted, so any audio bytes means sound; ~1.5s of decoded
         picture with zero audio means a silent file.
     A browser with none of these keeps the button, as before.
   =========================================================================== */
(function () {
  if (window.__rnVideoSound) return;
  window.__rnVideoSound = true;

  var SEL = '[id^="rn-hp-inr-"] video,[id^="rn-hp-motion-"] video,[id^="rn-mo-"] video,[id^="rn-story-"] video,[id^="rn-bb-"] .bb-main > video';
  /* PDP GALLERY, 16 Oct 2026. The buy box builds its main-frame <video> in
     script and swaps it as the shopper browses: removed when a photo is shown,
     re-pointed at a new file when moving video to video. So these frames are
     watched, a leftover button is removed when its video goes, and a video that
     loads a new file goes back to muted and is checked for audio again. The
     thumbnails (still frames) and the zoom overlay (native controls, with their
     own sound control) are not touched. The button sits under the 3D viewer
     overlay, which opens inside this same frame. */
  var WATCH = '[id^="rn-bb-"] .bb-main';

  var ICON_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="m22 9-6 6M16 9l6 6"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.8 5.2a9.5 9.5 0 0 1 0 13.6"/></svg>';

  (function style() {
    try {
      var s = document.createElement('style');
      s.textContent =
        '.rn-vsound{position:absolute;left:12px;bottom:12px;z-index:10;-webkit-transform:translateZ(0);transform:translateZ(0);touch-action:manipulation;-webkit-tap-highlight-color:transparent;width:36px;height:36px;padding:0;margin:0;border:0;border-radius:50%;' +
        'display:flex;align-items:center;justify-content:center;cursor:pointer;color:#fff;background:rgba(26,23,18,.55);' +
        '-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);box-shadow:0 2px 8px rgba(0,0,0,.18);transition:background .15s ease}' +
        '.rn-vsound[hidden]{display:none}' +
        '.rn-vsound::before{content:"";position:absolute;inset:-6px;border-radius:50%}' +
        '.rn-vsound:hover{background:rgba(26,23,18,.75)}' +
        '[id^="rn-bb-"] .bb-main > .rn-vsound{z-index:2}' +
        '.rn-vsound:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
        '.rn-vsound svg{width:18px;height:18px;display:block}' +
        '@media (max-width:600px){.rn-vsound{left:10px;bottom:10px;width:32px;height:32px}.rn-vsound svg{width:16px;height:16px}}';
      document.head.appendChild(s);
    } catch (e) {}
  })();

  var all = [];

  function sync(v) {
    var b = v.__rnSoundBtn;
    if (!b) return;
    var on = !v.muted;
    b.innerHTML = on ? ICON_ON : ICON_OFF;
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.setAttribute('aria-label', on ? 'Mute video' : 'Unmute video');
    b.title = on ? 'Mute' : 'Unmute';
  }

  function mute(v) {
    v.muted = true;
    v.removeAttribute('data-rn-unmuted');
    sync(v);
  }

  /* ALWAYS IN PLACE, NEVER THE FULL-SCREEN PLAYER, 15 Oct 2026. On phones some
     sections played with sound in place and others jumped into the iPhone's
     full-screen player. iOS decides per video, and does it more readily for a
     video that was not already playing when sound came on (Low Power Mode,
     not loaded yet); older iOS also only honours the prefixed attribute. So
     every video handled here is made inline-only before any play, and if iOS
     still opens its player it is closed straight away -- playback carries on
     in place. Picture-in-picture and AirPlay / cast takeovers are off too. */
  function keepInline(v) {
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.disablePictureInPicture = true;
    v.setAttribute('disablepictureinpicture', '');
    v.disableRemotePlayback = true;
    v.setAttribute('disableremoteplayback', '');
    function backInPlace() {
      try { if (v.webkitDisplayingFullscreen && v.webkitExitFullscreen) v.webkitExitFullscreen(); } catch (e) {}
      try { if (document.fullscreenElement === v && document.exitFullscreen) document.exitFullscreen(); } catch (e) {}
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    if (v.__rnInline) return;
    v.__rnInline = true;
    v.addEventListener('webkitbeginfullscreen', function () { setTimeout(backInPlace, 0); });
    v.addEventListener('fullscreenchange', function () { if (document.fullscreenElement === v) backInPlace(); });
  }

  function unmute(v) {
    keepInline(v);
    all.forEach(function (o) { if (o !== v && !o.muted) mute(o); });
    v.setAttribute('data-rn-unmuted', '');
    v.muted = false;
    if (v.volume === 0) v.volume = 1;
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    sync(v);
  }

  /* Calls back once with true (has sound), false (silent) or null (cannot tell). */
  function detectAudio(v, cb) {
    var done = false;
    function finish(r) { if (!done) { done = true; cb(r); } }
    function onMeta(fn) { if (v.readyState >= 1) fn(); else v.addEventListener('loadedmetadata', fn, { once: true }); }
    if (v.audioTracks && typeof v.audioTracks.length === 'number') {
      onMeta(function () { finish(v.audioTracks.length > 0); });
    } else if (typeof v.mozHasAudio === 'boolean') {
      onMeta(function () { finish(!!v.mozHasAudio); });
    } else if (typeof v.webkitAudioDecodedByteCount === 'number') {
      var check = function () {
        if (v.webkitAudioDecodedByteCount > 0) { v.removeEventListener('timeupdate', check); finish(true); }
        else if (v.currentTime >= 1.5 && v.webkitVideoDecodedByteCount > 0) { v.removeEventListener('timeupdate', check); finish(false); }
      };
      v.addEventListener('timeupdate', check);
      check();
    } else {
      finish(null);
    }
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting && !e.target.muted) mute(e.target); });
  }, { threshold: 0 }) : null;

  /* OUTSIDE A MASKED FRAME, 15 Oct 2026. rn-moments clips its video frames with
     -webkit-mask-image (to stop playing video spilling past the rounded corners
     in Safari). On iPhones that mask puts the video's native layer over
     everything inside the frame, so a tap meant for the button reached the
     video instead: no unmute, and iOS opened its full-screen player. The
     other sections have no mask and worked. So when the frame -- or anything
     between it and the section -- is masked, the button goes in the nearest
     unmasked ancestor and is positioned over the frame's bottom-left corner,
     kept in place as the layout changes. Unmasked frames are unaffected. */
  function masked(el) {
    var cs = getComputedStyle(el);
    var m = cs.webkitMaskImage || cs.maskImage;
    return !!m && m !== 'none';
  }

  function attach(v) {
    if (v.__rnSoundBtn) return;
    var frame = v.parentElement;
    if (!frame) return;
    var host = frame;
    while (host && host !== document.body && masked(host)) host = host.parentElement;
    if (!host || host === document.body) host = frame;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    /* MOBILE TAPS, 15 Oct 2026. iOS draws a playing <video> on its own layer,
       which can sit above an element placed over it whatever its z-index, and
       then takes the tap -- the button looked fine but did nothing. The video
       has no controls and no section listens for taps on it, so it simply
       stops taking them; the button also gets its own layer (translateZ). */
    v.style.pointerEvents = 'none';
    keepInline(v);
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rn-vsound';
    b.hidden = true;
    v.__rnSoundBtn = b;
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (v.muted) unmute(v); else mute(v);
    });
    v.addEventListener('volumechange', function () { sync(v); });
    host.appendChild(b);
    if (host !== frame) {
      var place = function () {
        var f = frame.getBoundingClientRect(), h = host.getBoundingClientRect();
        var gap = window.matchMedia('(max-width:600px)').matches ? 10 : 12;
        b.style.left = Math.round(f.left - h.left + host.clientLeft + gap) + 'px';
        b.style.bottom = 'auto';
        b.style.top = Math.round(f.bottom - h.top - host.clientTop - gap - b.offsetHeight) + 'px';
      };
      place();
      if ('ResizeObserver' in window) { var ro = new ResizeObserver(place); ro.observe(frame); ro.observe(host); }
      window.addEventListener('resize', place);
      b.addEventListener('transitionend', place);
      v.__rnSoundPlace = place;
    }
    /* CLEAR OF THE SLIDER CONTROLS, 16 Oct 2026. In the PDP gallery the arrows
       and dots (.bb-ctrl) are centred, but on phones they run nearly the full
       width and covered the bottom-left corner. Measured, not guessed: when
       they overlap the button's column the button lifts to sit just above
       them; when there is room (tablet, desktop) it stays in the corner. */
    var ctrl = host.querySelector('.bb-ctrl');
    if (ctrl) {
      var clear = function () {
        b.style.bottom = '';
        if (!ctrl.offsetParent) return;
        var c = ctrl.getBoundingClientRect(), h = host.getBoundingClientRect();
        var left = h.left + (parseFloat(getComputedStyle(b).left) || 12), w = b.offsetWidth || 36;
        if (c.left < left + w + 6 && c.right > left - 6) b.style.bottom = Math.round(h.bottom - c.top + 8) + 'px';
      };
      clear();
      if ('ResizeObserver' in window) { var cro = new ResizeObserver(clear); cro.observe(ctrl); cro.observe(host); }
      window.addEventListener('resize', clear);
      v.__rnSoundClear = clear;
    }
    all.push(v);
    if (io) io.observe(v);
    sync(v);
    detectAudio(v, function (has) { b.hidden = has === false; if (v.__rnSoundPlace) v.__rnSoundPlace(); if (v.__rnSoundClear) v.__rnSoundClear(); });
    /* a new file in the same element (the PDP gallery moving video to video):
       start muted again and find out whether this clip has sound */
    v.addEventListener('loadstart', function () {
      if (!v.muted) mute(v);
      b.hidden = true;
      detectAudio(v, function (has) { b.hidden = has === false; if (v.__rnSoundPlace) v.__rnSoundPlace(); if (v.__rnSoundClear) v.__rnSoundClear(); });
    });
  }

  function tidy() {
    all = all.filter(function (v) {
      if (v.isConnected) return true;
      if (v.__rnSoundBtn && v.__rnSoundBtn.parentNode) v.__rnSoundBtn.parentNode.removeChild(v.__rnSoundBtn);
      if (io) io.unobserve(v);
      return false;
    });
  }

  function run() { tidy(); Array.prototype.forEach.call(document.querySelectorAll(SEL), attach); }

  function watch() {
    if (!('MutationObserver' in window)) return;
    Array.prototype.forEach.call(document.querySelectorAll(WATCH), function (el) {
      if (el.__rnSoundWatch) return;
      el.__rnSoundWatch = true;
      new MutationObserver(run).observe(el, { childList: true });
    });
  }

  function start() { run(); watch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
